// Formatted in UTC because `resample_month` is a date-only value, which parses
// to UTC midnight — formatting it in local time would roll it back to the
// previous month for any viewer west of UTC.
export const formatRetestMonth = (date) => date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
});
//# sourceMappingURL=formatRetestMonth.js.map